import Mapper from '@/models/mappers/Mapper';
import { PreorderProductDTO } from '@/api/dto/PreorderProductDTO';
import { mapValueToInterface } from '@/utils/models';
import { PreorderProduct } from '@/models/entities/PreorderProduct';

export class PreorderProductMapper extends Mapper<PreorderProduct, PreorderProductDTO> {
  mapFromDTO(preorderProductDTO: PreorderProductDTO): PreorderProduct {
    return new PreorderProduct(<Partial<PreorderProduct>>preorderProductDTO);
  }

  mapToDTO(preorderProduct: PreorderProduct): PreorderProductDTO {
    return mapValueToInterface(preorderProduct) as PreorderProductDTO;
  }
}
